import "regenerator-runtime/runtime";
import axios from 'axios';
let React = require('react');

class Arcadier {

    async OpenPayWebhook(requestBody) {
        let pluginId = process.env.OPENPAY_webhook;
        let APIurl = `https://${process.env.BASE_URL}/user/plugins/${pluginId}/OpenPay.php`;

        let config = {
            method: 'post',
            url: APIurl,
            headers: {
                'Content-type': 'application/json', 
            },
            data: requestBody
        };

        var response;

        await axios(config)
            .then(response => {
                console.log(response)
                response = response.data;


            })
            .catch(error => console.error(error));

        return response;
    }

   
}

module.exports = Arcadier;